/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:51:06
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-01 11:39:10
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC/ErrorProcessingComponent.tsx
 */
import React from 'react';

import { useSelector, useDispatch } from 'react-redux';

// import GeneralCollapseWrapper from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseWrapper';
// import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';
// import GeneralCollapseHeader from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseHeader';
// import { Collapse } from '@/src/components/Antd';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import CollapseWrapper from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelCollapseWrapper';

import { useError } from './hooks';
//import useErrorProcessing from './useErrorProcessing';
import { currentSelectedStyle } from 'src/constrains/SalesChannelStyleSelect/slice';
import { currentSelectedSize } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer/slice';
// const headerPropsProcessor = (headerProps, isPrimary) => {
//   const _headerProps = { ...(headerProps || {}) };
//   if (_headerProps.hideDotsWhenNotPrimary && !isPrimary) {
//     _headerProps.hasDots = false;
//   }
//   return _headerProps;
// };

const ErrorProcessingComponent = (props?: any) => {
  const {
    getCollapseOpenStatus,
    onCollapseOpen,
    headerProps = {},
    id,
    getContent,
    title,
    titleStyle,
    renderTitle,
    getErrorDisplay,
    onErrorChange,
    validation,
    expandOffset,
    getSubmitStamp,
    isNotRedux,
    bordered,
    renderComponent,
    titleContainerClassName,
    collapseProps: _collapseProps,
    data,
  } = props;

  // const { validationProps } = props;
  const _d = useDispatch();
  const isPrimary = useSelector(isPrimaryLanguage());
  const currentStyle = useSelector(currentSelectedStyle());
  const currentSize = useSelector(currentSelectedSize());
  const _e: any = getErrorDisplay
    ? isNotRedux
      ? getErrorDisplay(id)
      : useSelector(getErrorDisplay(id))
    : { display: false, hasError: false };

  const { display: _display, hasError: _hasError } = _e;

  const _open = isNotRedux
    ? getCollapseOpenStatus(id)
    : useSelector(getCollapseOpenStatus(id));

  const _data: any =
    data ||
    (getContent ? (isNotRedux ? getContent() : useSelector(getContent())) : {}); //最好别在这里更新数据

  const stamp = getSubmitStamp
    ? isNotRedux
      ? getSubmitStamp()
      : useSelector(getSubmitStamp())
    : null;

  const {
    specificError, //->对应现在应该显示error,对应pDataError里面的数据
    currentHasError,
    generalError, //->对应现在应该显示error,对应pDataError里面的数据
    currentHasPreviousError, //->对应现在应该显示HasError,对应pDataError里面的数据
  } = useError({
    data: _data,
    open: _open,
    display: _display,
    validation: validation
      ? (x) => {
          //console.log('x', x);
          return validation(x, {
            isPrimary,
            style: currentStyle,
            breakpoint: currentSize,
          });
        }
      : null,
    isPrimary,
    stamp,
    errorDisplayHasError: _hasError,
    onErrorChange,
    id,
    isRedux: true,
  });

  const errorProcessingProps = {
    specificError: specificError || {},
    display: _display,
    currentHasError,
  };

  const handleOnCollapseOpen = (status) => {
    const _g = status ? [id] : [];
    if (isNotRedux) {
      onCollapseOpen({ idArr: _g });
    } else {
      _d(onCollapseOpen({ idArr: _g }));
    }
  };

  // const renderTitle = () => {
  //   return (
  //     <GeneralCollapseHeader
  //       content={title}
  //       err={_display && currentHasPreviousError}
  //       {...(headerPropsProcessor(headerProps, isPrimary) || {})}
  //     />
  //   );
  // };

  const collapseProps = {
    id,
    open: _open,
    title: title || (renderTitle ? renderTitle(errorProcessingProps) : null),
    titleStyle,
    displayError: _display && currentHasPreviousError,
    headerProps,
    isPrimary,
    generalError,
    expandOffset,
    bordered,
    titleContainerClassName,
    onCollapseOpen: handleOnCollapseOpen,
    collapseProps: _collapseProps,
  };

  return (
    <CollapseWrapper {...collapseProps}>
      {renderComponent(errorProcessingProps)}
    </CollapseWrapper>
  );
};
export default ErrorProcessingComponent;
